import React, { lazy, Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import { useLanguage } from "../../context/LanguageContext";
import SectionList from "../../components/SharedSections/SectionList";
import "./css/resultpage.scss";
import "../PolishCulture/css/polishCulture.scss";
import "../PolishCulture/css/sectionPage.scss"

const LazyComponents = {
  "/home": lazy(() => import("../Home/Home")),
  "/aboutMe": lazy(() => import("../AboutMe/AboutMe")),
  "/polishCulture": lazy(() => import("../PolishCulture/PolishCulture")),
  "/forForeigners": lazy(() => import("../ForForeigners/ForForeigners")),
  "/contact": lazy(() => import("../Contact/Contact")),
  "/legendaryStories": lazy(() => import("../LegendaryStories/LegendaryStories")),
};

function ResultPage() {
  const location = useLocation();
  const { translations } = useLanguage();
  const [searchData, setSearchData] = useState(() => {
    return (
      location.state || JSON.parse(sessionStorage.getItem("searchResult")) || {}
    );
  });

  useEffect(() => {
    if (location.state) {
      setSearchData(location.state);
      sessionStorage.setItem("searchResult", JSON.stringify(location.state));
    }
  }, [location.state]);

  const { path, title } = searchData;
  const searchQuery = title?.toLowerCase() || "";

  const searchSections = (sections) => {
    return sections.filter((section) => {
      const inTitle = section.title?.toLowerCase().includes(searchQuery);
      const inSub = section.sections?.some((sub) =>
        sub.title?.toLowerCase().includes(searchQuery)
      );
      return inTitle || inSub;
    });
  };

  // 🔍 Polish Culture
  if (path?.startsWith("/polishCulture") && translations?.polishCulture) {
    const matchedSections = searchSections(translations.polishCulture.sections);

    return (
      <div className="result container">
        <p className="result__text">Search results for "{title}"</p>
        {matchedSections.length > 0 ? (
          <SectionList
            title={`Found ${matchedSections.length} result(s) in Polish Culture`}
            sections={matchedSections}
            basePath="polish-culture"
          />
        ) : (
          <p className="result__not">Nothing found in Polish Culture.</p>
        )}
      </div>
    );
  }

  // 🔍 Legendary Stories
  if (path?.startsWith("/legendaryStories") && translations?.legendaryStories) {
    const matchedSections = searchSections(translations.legendaryStories.sections);

    return (
      <div className="result container">
        <p className="result__text">Search results for "{title}"</p>
        {matchedSections.length > 0 ? (
          <SectionList
            title={`Found ${matchedSections.length} result(s) in Legendary Stories`}
            sections={matchedSections}
            basePath="legendary-stories"
          />
        ) : (
          <p className="result__not">Nothing found in Legendary Stories.</p>
        )}
      </div>
    );
  }

  // 🔄 Динамический компонент для других страниц
  const Component = path ? LazyComponents[path] : null;

  return (
    <div className="result container">
      <p className="result__text">Search results for "{title}"</p>
      {Component ? (
        <Suspense fallback={<Loader />}>
          <Component searchTitle={title} />
        </Suspense>
      ) : (
        <p className="result__not">
          Sorry, no posts were found. Try searching for something else.
        </p>
      )}
    </div>
  );
}

export default ResultPage;
